/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsBoiler: {
  name: 'boiler';
  data: string;
} = {
  name: 'boiler',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.618 2a2 2 0 0 0-.362.033 1.001 1.001 0 0 0-1.235.763 2 2 0 0 0-.192.31l-3.618 7.236a2 2 0 0 0-.211.894V14a2 2 0 0 0 2 2h2v2c0 .205.03.403.088.589A.997.997 0 0 0 6 19v2a1 1 0 1 0 2 0v-1h3v1a1 1 0 1 0 2 0v-1h3v1a1 1 0 1 0 2 0v-2a.997.997 0 0 0-.088-.411c.057-.186.088-.384.088-.589v-2h2a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-2V4a2 2 0 0 0-2-2H7.618ZM8 4v2h8V4H8Zm-4 7.236 2-4V14H4v-2.764ZM8 15a.997.997 0 0 1-.088.411c.057.186.088.384.088.589v2h8V8H8v7Zm10-1V8h2v6h-2Z" fill="currentColor"/></svg>`,
};
